import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  Input,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { BaseComponentDirective, BooleanObservableService } from '@streamamg/amg-common';
import { CLOUD_PAY_MODAL_KEY, CloudPayService } from '@streamamg/cloud-pay-lib';
import { Store } from '@ngrx/store';
import { Router } from '@angular/router';
import { AppState } from '../../store';
import { selectFixedPages } from '../../store/fixed-pages/fixedPages.selectors';

@Component({
  selector: 'app-login-button',
  templateUrl: './login-button.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoginButtonComponent extends BaseComponentDirective implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('menuContainer') $menuContainer: ElementRef;
  @Input() isLoggedIn: boolean;
  @Input() iconOnly: boolean;
  @Input() buttonClasses: string;
  @Input() typeCta: 'login' | 'login_to_your_account' = 'login';
  public menuOpened: boolean;
  public myAccountUrl: string;

  constructor(
    private booleanObservableService: BooleanObservableService,
    protected cd: ChangeDetectorRef,
    private router: Router,
    private cloudPayService: CloudPayService,
    private store: Store<AppState>,
  ) {
    super();
  }

  ngOnInit(): void {

    super.subSink = this.store.select(selectFixedPages)
      .subscribe((data) => {
        this.myAccountUrl = `/${data.my_account}`;
        this.cd.markForCheck();
      });
  }

  ngAfterViewInit(): void {

    if (this.$menuContainer?.nativeElement) {

      window.addEventListener('click', this.onClickMenu);
    }
  }

  onClickMenu = (e) => {

    if (this.$menuContainer?.nativeElement?.contains(e.target)) {
      if (this.isLoggedIn) {

        this.menuOpened = !this.menuOpened;
        this.cd.detectChanges();
        return;
      }
      this.booleanObservableService.trigger(CLOUD_PAY_MODAL_KEY, true);
    } else {
      if (this.isLoggedIn) {

        this.menuOpened = false;
        this.cd.detectChanges();
      }
    }
  };


  public onLogOut($event: Event): void {

    $event.preventDefault();

    this.cloudPayService.logOut();
  }

  ngOnDestroy(): void {
    window.removeEventListener('click', this.onClickMenu, false);
  }

  public onClick(): void {
    this.booleanObservableService.trigger(CLOUD_PAY_MODAL_KEY, true);
  }
}
